import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

export const SystemViews = () => {
  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/system`} component={lazy(() => import(`./Dashboard`))} />
        <Route path={`${APP_PREFIX_PATH}/config`} component={lazy(() => import(`./Config`))} />
        <Route path={`${APP_PREFIX_PATH}/utilities`} component={lazy(() => import(`./Utilities`))} />
        <Route path={`${APP_PREFIX_PATH}/permissions`} component={lazy(() => import(`./Permissions`))} />
        
        <Redirect exact from={`${APP_PREFIX_PATH}/`} to={`${APP_PREFIX_PATH}/dashboard`} />
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/pool/404`} />
      </Switch>
    </Suspense>
  )
}

export default React.memo(SystemViews);